import React, { createContext, useContext, useState, ReactNode } from "react";

export interface PatientPrefill {
  name?: string;
  dob?: string | null;
  gender?: string | null;
  abha_id?: string;
}

interface AddPatientContextType {
  isAddPatientModalOpen: boolean;
  prefill: PatientPrefill | null;
  openAddPatientModal: (prefill?: PatientPrefill) => void;
  closeAddPatientModal: () => void;
}

const AddPatientContext = createContext<AddPatientContextType | undefined>(undefined);

export const AddPatientProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAddPatientModalOpen, setIsAddPatientModalOpen] = useState(false);
  const [prefill, setPrefill] = useState<PatientPrefill | null>(null);

  const openAddPatientModal = (data?: PatientPrefill) => {
    setPrefill(data ?? null);
    setIsAddPatientModalOpen(true);
  };

  const closeAddPatientModal = () => {
    setIsAddPatientModalOpen(false);
    setPrefill(null);
  };

  return (
    <AddPatientContext.Provider
      value={{ isAddPatientModalOpen, prefill, openAddPatientModal, closeAddPatientModal }}
    >
      {children}
    </AddPatientContext.Provider>
  );
};

export const useAddPatient = () => {
  const context = useContext(AddPatientContext);
  if (context === undefined) {
    throw new Error("useAddPatient must be used within an AddPatientProvider");
  }
  return context;
};
